export class SelectTaskUI {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get task() {
        return this.parent;
    }
    get shouldShowTemporaryFalseFeedback_1500ms() {
        if (this.task.taskProgress.isTaskComplete)
            return false;
        if (this.task.question.task !== this.task)
            return false;
        if (this.task.taskProgress.secondsSinceSelection < 0)
            return false;
        if (this.task.taskProgress.secondsSinceSelection > 1500)
            return false;
        return true;
    }
}
